var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"col":"12"}},[_c('userList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }